import React from "react";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  FormControlLabel,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";

import CrmShell from "../components/CrmShell";
import { CrmPageHeader, CrmPanel, MetricCard, crmUi } from "../components/CrmUi";
import NetworkTree from "../components/NetworkTree";
import { network } from "../demoData";

const CrmBusinessNetworkDetailsPage = () => (
  <CrmShell>
    <CrmPageHeader
      title={network.name}
      subtitle={`Affärsnätverk · Nätverksägare: ${network.owner}`}
      actions={[
        <Button key="edit" size="small" variant="outlined" startIcon={<EditOutlinedIcon />} sx={{ textTransform: "none" }}>
          Redigera nätverk
        </Button>,
        <Button key="add" size="small" variant="contained" startIcon={<AddOutlinedIcon />} sx={{ textTransform: "none" }}>
          Lägg till organisation
        </Button>,
      ]}
    />

    <Grid container spacing={1.15}>
      <Grid item xs={12} sm={6} lg={3}>
        <MetricCard label="Organisationer" value={network.organizations} icon={<ApartmentOutlinedIcon />} />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <MetricCard label="Nivåer" value={network.levels} icon={<LayersOutlinedIcon />} />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <MetricCard label="Debiteras via parent" value={network.billedViaParent} icon={<PaymentsOutlinedIcon />} tone="warning" />
      </Grid>
      <Grid item xs={12} sm={6} lg={3}>
        <MetricCard label="Ägare" value="Wilma" icon={<PersonOutlineOutlinedIcon />} />
      </Grid>

      <Grid item xs={12} xl={8}>
        <CrmPanel sx={{ p: 1.4, height: "100%" }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Box>
              <Typography sx={{ color: crmUi.text, fontSize: 13.5, fontWeight: 550 }}>Nätverksträd</Typography>
              <Typography sx={{ mt: 0.15, color: crmUi.muted, fontSize: 10.2 }}>
                Visar relation, nivå och debiteringsansvar.
              </Typography>
            </Box>
            <Stack direction="row" spacing={0.5}>
              <Button size="small" variant="outlined" sx={{ textTransform: "none" }}>Expandera alla</Button>
              <Button size="small" variant="outlined" sx={{ textTransform: "none" }}>Kollapsa alla</Button>
            </Stack>
          </Stack>
          <Box sx={{ mt: 1.1, p: 1, bgcolor: "#fbfcfd", borderRadius: 1.3 }}>
            <NetworkTree roots={network.children} />
          </Box>
        </CrmPanel>
      </Grid>

      <Grid item xs={12} xl={4}>
        <CrmPanel sx={{ p: 1.5 }}>
          <Typography sx={{ color: crmUi.text, fontSize: 14, fontWeight: 560 }}>
            Redigera organisation
          </Typography>
          <Typography sx={{ mt: 0.2, color: crmUi.muted, fontSize: 10.4 }}>
            Exempel: Tryckeri Alfa · nivå 4
          </Typography>

          <Stack spacing={1.05} sx={{ mt: 1.5 }}>
            <TextField size="small" label="Organisationsnamn" value="Tryckeri Alfa" />
            <TextField size="small" label="Roll i nätverket" select value="Leverantör">
              <MenuItem value="Leverantör">Leverantör</MenuItem>
              <MenuItem value="Partner">Partner</MenuItem>
              <MenuItem value="Direkt kund">Direkt kund</MenuItem>
            </TextField>
            <TextField size="small" label="Relation till UniQueue" select value="Partner (ej kund)">
              <MenuItem value="Partner (ej kund)">Partner (ej kund)</MenuItem>
              <MenuItem value="Direkt kund">Direkt kund</MenuItem>
              <MenuItem value="Nätverksorganisation">Nätverksorganisation</MenuItem>
            </TextField>
            <TextField size="small" label="Överordnad organisation" value="Freelance Sweden" />

            <Box>
              <Typography sx={{ color: crmUi.muted, fontSize: 10.2, mb: 0.45 }}>Debiteras av</Typography>
              <RadioGroup value="parent">
                <FormControlLabel value="direct" control={<Radio size="small" />} label="Debiteras direkt" />
                <FormControlLabel value="parent" control={<Radio size="small" />} label="Debiteras av överordnad organisation" />
                <FormControlLabel value="other" control={<Radio size="small" />} label="Debiteras av annan organisation" />
              </RadioGroup>
            </Box>

            <TextField size="small" label="Kundansvarig" value="Maria Svensson" />
            <TextField size="small" label="Aktiv från" value="2024-05-01" />
            <TextField size="small" label="Status" select value="Aktiv">
              <MenuItem value="Aktiv">Aktiv</MenuItem>
              <MenuItem value="Inaktiv">Inaktiv</MenuItem>
            </TextField>
            <TextField size="small" multiline minRows={3} label="Anteckning" value="Strategisk tryckpartner med hög kapacitet och snabb leverans." />

            <Stack direction="row" spacing={0.7} justifyContent="flex-end">
              <Button size="small" variant="outlined" sx={{ textTransform: "none" }}>Avbryt</Button>
              <Button size="small" variant="contained" sx={{ textTransform: "none" }}>Spara ändringar</Button>
            </Stack>
          </Stack>
        </CrmPanel>
      </Grid>
    </Grid>
  </CrmShell>
);

export default CrmBusinessNetworkDetailsPage;
